'use client';
import { FC } from 'react';

import { useTranslations } from 'next-intl';
import { useTimeLeft } from '../../../../../packages/ui/lib/hooks/use-time-left';
import { cn } from '../../../../../packages/ui/lib/lib';

export const EventEndedBanner: FC<{
  event: { endDate: string };
  className?: string;
}> = ({ event, className }) => {
  const t = useTranslations();
  const { ended } = useTimeLeft(event.endDate);
  if (!ended) return null;
  return (
    <div
      className={cn('bg-back600 flex flex-col items-center px-4', className)}
      style={{
        backgroundImage: 'linear-gradient(rgb(255, 214, 0), rgb(188, 135, 0))',
      }}
    >
      <div className="text-base font-semibold text-black md:text-xl">
        {t('event_ended')}
      </div>
      <div className="text-center text-base font-medium text-black md:text-xl">
        {t('event_ended_description')}
      </div>
    </div>
  );
};
